import { Divider } from "antd";
import React from "react";

const ChargeLineItem = ({
  charge,
  allCharges,
  availableCharges,
  billSubTotalBeforeCharges,
  onDelete,
  onUpdate,
  readOnly = false,
}) => {
  const selectedCharge = allCharges.find((ch) => ch.id === charge.chargeId);

  // Get available charges including the currently selected one
  const availableOptions = [
    ...availableCharges,
    ...(selectedCharge ? [selectedCharge] : []),
  ];

  // Calculate the real-time value based on valueType
  const calculateChargeValue = () => {
    if (!selectedCharge) return 0;

    if (selectedCharge.valueType === "fixed") {
      return selectedCharge.value;
    } else if (selectedCharge.valueType === "percentage") {
      return (billSubTotalBeforeCharges * selectedCharge.value) / 100;
    }
    return 0;
  };

  const calculatedValue = calculateChargeValue();

  // Update the charge value when the charge selection changes
  const handleChargeChange = (e) => {
    const selectedCh = allCharges.find((ch) => ch.id === e.target.value);

    if (selectedCh) {
      let newValue = 0;
      if (selectedCh.valueType === "fixed") {
        newValue = selectedCh.value;
      } else if (selectedCh.valueType === "percentage") {
        newValue = (billSubTotalBeforeCharges * selectedCh.value) / 100;
      }

      onUpdate({
        id: charge.id,
        chargeId: e.target.value,
        value: newValue,
      });
    }
  };

  return (
    <>
      <div className="col-md-6">
        <select
          value={charge.chargeId || ""}
          name="chargeId"
          onChange={handleChargeChange}
          disabled={readOnly}
          className="input w-100">
          <option value="" disabled>
            Select a charge
          </option>
          {availableOptions.map((ch) => (
            <option key={ch.id} value={ch.id}>
              {ch.title}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-4">
        {selectedCharge ? (
          <>
            ₵{" "}
            <span className="fw-bold">
              {parseFloat(calculatedValue).toFixed(1)}
            </span>
            {selectedCharge.valueType === "percentage" && (
              <span className="ms-2 text-muted">
                ({parseFloat(selectedCharge.value).toFixed(0)}% of ₵
                {billSubTotalBeforeCharges})
              </span>
            )}
          </>
        ) : (
          <span className="text-muted">Select a charge</span>
        )}
      </div>
      <div className="col-md-2 g-0">
        {!readOnly && (
          <button
            className="button is-ghost is-small"
            onClick={() => onDelete(charge.id)}>
            <span className="bi bi-trash text-danger h6 mb-0"></span>
          </button>
        )}
      </div>
      <Divider className="my-2" />
    </>
  );
};

export default ChargeLineItem;
